@custom-media --mobile (max-width: 768px);

.container {
  color: var(--white);
  bottom: 1em;
  position: fixed;
  right: 1em;
  z-index: 4;

  @media print {
    display: none;
  }
}

.closed {
  background-color: var(--darkBlueActive);
  min-height: 5em;
  width: 5em;
  text-align: center;
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  @media (--mobile) {
    height: 3em;
    width: 3em;
  }
}

.label {
  font-size: 0.7em;
  display: block;
}

.form {
  background-color: var(--darkBlueActive);
  padding: 1em;
  width: 27em;

  @media (--mobile) {
    width: 300px;
  }

  &>textarea {
    border: none;
    color: var(--white);
    resize: none;
    background-color: transparent;
  }
}

.success {
  background-color: var(--greenSuccess);
  height: 5em;
  width: 5em;
  text-align: center;
  cursor: pointer;
  position: relative;

  p {
    margin-bottom: 0;
  }
}

.buttons {
  display: flex;
  justify-content: space-between;
}
